import { getAboutPage } from "../../../config/aboutContent.js";
import { buildAnimatedHeading } from "../../HeroTitleAnimation.js";
import { buildSectionPillRow } from "../../components/SectionPill.js";

export function createAboutTimelineSection() {
  const { timeline } = getAboutPage();
  const section = document.createElement("section");
  section.id = "path";
  section.className = "section about-timeline";

  section.innerHTML = `
    <div class="section__inner">
      <div class="about-timeline__intro reveal">
        ${buildSectionPillRow(timeline.badge)}
        <h2 class="about-timeline__title">${buildAnimatedHeading(timeline.titleSegments)}</h2>
        <p class="about-timeline__subtitle">${timeline.subtitle}</p>
      </div>
      <ol class="about-timeline__track">
        ${timeline.steps
          .map(
            (step, i) => `
          <li class="about-timeline__step reveal" style="--delay: ${0.08 * (i + 1)}s; --step-i: ${i}">
            <span class="about-timeline__dot" aria-hidden="true"></span>
            <span class="about-timeline__step-index">${step.step}</span>
            <h3>${step.title}</h3>
            <p>${step.body}</p>
          </li>
        `
          )
          .join("")}
      </ol>
    </div>
  `;

  return section;
}
